import React, { useEffect, useState } from 'react';
import './Stepper.pcss';
import { ReactComponent as ImageBlueIcon } from 'assets/icons/widgets/image-icon-blue.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import classnames from 'classnames';

type StepperProps = {
  currentIndex: number;
  totalAmount: number;
  showAddIcon: boolean;
  onCardSelected: (index: number) => void;
  onAddNewCard: (props: any) => void;
};

type StepperItemProps = {
  selectedIndex?: number;
  currentIndex: number;
  stepSelected?: boolean;
  isAddMoreIcon: boolean;
  onCardSelected: (index: number) => void;
  onAddNewCard: (props: any) => void;
};

export const Stepper = ({
  currentIndex,
  totalAmount,
  onCardSelected,
  onAddNewCard,
  showAddIcon,
}: StepperProps) => {
  const itemsToRender = showAddIcon ? totalAmount + 1 : totalAmount;
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    setSelectedIndex(currentIndex);
  }, [currentIndex]);
  return (
    <ul className="stepper__container">
      {[...Array(totalAmount).keys()].map(index => (
        <StepperItem
          key={`${index}-item`}
          selectedIndex={selectedIndex}
          onCardSelected={onCardSelected}
          onAddNewCard={onAddNewCard}
          currentIndex={index}
          isAddMoreIcon={false}
          stepSelected={index === selectedIndex}
        />
      ))}
      {showAddIcon && (
        <StepperItem
          onCardSelected={onCardSelected}
          onAddNewCard={onAddNewCard}
          currentIndex={itemsToRender}
          isAddMoreIcon={true}
        />
      )}
    </ul>
  );
};

const StepperItem = ({
  onCardSelected,
  onAddNewCard,
  currentIndex = 0,
  isAddMoreIcon,
  selectedIndex,
}: StepperItemProps) => {
  const clickHandler = isAddMoreIcon ? onAddNewCard : onCardSelected;
  return (
    <li
      className={classnames('stepper__item', {
        'stepper__item-active':
          !isAddMoreIcon && selectedIndex === currentIndex,
      })}
      onClick={() => clickHandler(currentIndex)}
    >
      {!isAddMoreIcon && (
        <div className="stepper_item-container">
          <ImageBlueIcon
            className={classnames({
              'stepper__item-image': selectedIndex === currentIndex,
              'stepper__item-image-grey': selectedIndex !== currentIndex,
            })}
          />
          <hr
            className={classnames('stepper__item-image-line', {
              'stepper__item-image-line-inactive':
                selectedIndex !== currentIndex,
              'stepper__item-image-line-active': selectedIndex === currentIndex,
            })}
          />
          <hr
            className={classnames('stepper__item-image-line', {
              'stepper__item-image-line-inactive':
                selectedIndex !== currentIndex,
              'stepper__item-image-line-active': selectedIndex === currentIndex,
            })}
          />
        </div>
      )}
      {isAddMoreIcon && (
        <div className="stepper__item-image-plus-container">
          <PlusIcon className="stepper__item-image-plus" />
        </div>
      )}
    </li>
  );
};
